import { Check, Sparkles } from "lucide-react";

const TIERS = [
  {
    name: "Einzelbewertung",
    badge: "Perfekt für den Start",
    price: "45 €",
    sub: "Endpreis",
    desc: "Aufbereitung und strukturierte Einreichung einer einzelnen Bewertung.",
    features: ["Komplette Abwicklung mit Google", "Keine versteckten Kosten – Festpreis", "Strukturierte Meldung über offiziellen Weg"],
    highlight: false,
    cta: "Jetzt anfragen",
  },
  {
    name: "2–9 Bewertungen",
    badge: "Bestes Preis-Leistungs-Verhältnis",
    price: "35 €",
    sub: "pro Bewertung – Endpreis",
    desc: "Mengenrabatt bei mehreren Bewertungen, die gleichzeitig bearbeitet werden.",
    features: ["Komplette Abwicklung mit Google", "Keine versteckten Kosten – Festpreis", "Priorisierte Bearbeitung"],
    highlight: true,
    cta: "Jetzt anfragen",
  },
  {
    name: "Ab 10 Bewertungen",
    badge: "Individuelles Angebot",
    price: "Nach Angebot",
    sub: "individuell kalkuliert",
    desc: "Maßgeschneidertes Angebot mit zusätzlichem Mengenrabatt.",
    features: ["Komplette Abwicklung mit Google", "Festpreis nach Erstgespräch", "Persönlicher Ansprechpartner"],
    highlight: false,
    cta: "Angebot anfragen",
  },
];

export default function Pricing() {
  return (
    <section id="preise" data-testid="pricing-section" className="relative py-20 lg:py-28 border-t border-black/[0.05]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#2b2620]">Transparente Preise</div>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#2b2620]">
            Sie zahlen für die Leistung – nicht für ein Versprechen.
          </h2>
          <p className="mt-5 text-[#6b5f52] leading-relaxed">
            Die Vergütung erfolgt für die strukturierte Aufbereitung und Einreichung gemäß den geltenden Plattform-Richtlinien – nicht für einen garantierten Lösch-Erfolg.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-3 gap-6">
          {TIERS.map((t, i) => (
            <div
              key={t.name}
              data-testid={`pricing-tier-${i + 1}`}
              className={`relative rounded-3xl p-8 lg:p-10 border transition-all ${
                t.highlight
                  ? "bg-gradient-to-b from-[#fafbfd] to-[#ffffff] border-[#2b2620]/50 soft-glow lg:-translate-y-3"
                  : "bg-[#faf6ef] border-black/[0.08] hover:border-black/[0.14]"
              }`}
            >
              {t.highlight && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#2b2620] text-white text-xs font-semibold">
                  <Sparkles className="w-3.5 h-3.5" /> Beliebt
                </div>
              )}
              <div className="text-xs uppercase tracking-[0.18em] text-[#2b2620]/80">{t.badge}</div>
              <h3 className="mt-3 font-heading text-2xl font-semibold text-[#2b2620]">{t.name}</h3>
              <div className="mt-6 flex items-baseline gap-2">
                <span className="font-heading text-5xl font-semibold text-[#2b2620]">{t.price}</span>
              </div>
              <div className="text-sm text-[#6b5f52]">{t.sub}</div>
              <p className="mt-5 text-sm text-[#6b5f52] leading-relaxed">{t.desc}</p>
              <ul className="mt-6 space-y-3">
                {t.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm text-[#3a3128]">
                    <Check className="w-4 h-4 mt-0.5 text-[#2b2620] shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#kontakt"
                data-testid={`pricing-cta-${i + 1}`}
                className={`mt-8 inline-flex w-full items-center justify-center px-6 py-3.5 rounded-full font-semibold transition-colors ${
                  t.highlight
                    ? "bg-[#2b2620] text-white hover:bg-[#4a4038]"
                    : "border border-black/10 text-[#2b2620] hover:bg-black/[0.03]"
                }`}
              >
                {t.cta}
              </a>
            </div>
          ))}
        </div>

        <p className="mt-10 text-xs text-[#8a7f70] max-w-3xl">
          Zahlung erfolgt bei Beauftragung, vor der Einreichung der Meldung. Keine laufenden Kosten, keine Abonnements, keine versteckten Gebühren. Die unverbindliche Vorab-Rückmeldung ist immer kostenfrei.
        </p>
        <p className="mt-4 text-xs text-[#8a7f70] max-w-3xl" data-testid="kleinunternehmer-hinweis">
          Alle angegebenen Preise sind Endpreise zuzüglich Liefer-/Versandkosten. Es erfolgt kein Ausweis der Umsatzsteuer aufgrund der Anwendung der Kleinunternehmerregelung gemäß § 19 UStG.
        </p>
      </div>
    </section>
  );
}
